import type { Locale } from './types'

export default async function getMessages(locale: Locale): Promise<IntlMessages> {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
  return (await import(`@betterplace/locales/messages/org/${locale}.json`)).default
}
